<template>
  <div>
    <div class="sign-content">
      <div class="sign-content-h2" v-if="isChinese === 'zh-cn' || isChinese === 'ru-ru'">{{$t('page.moralAgree.contentTitle')}}</div>
      <div class="sign-content-text">
        <div class="sign-content-text-h2">{{isChinese === 'zh-cn' || isChinese === 'ru-ru' || isChinese === 'ar'?$t('page.moralAgree.contentH')[0]:$t('page.moralAgree.contentH')}}</div>
        <div class="sign-content-text-main" v-if="isChinese === 'zh-cn' || isChinese === 'ru-ru' || isChinese === 'ar'">
          <div class="sign-content-text-partyname">{{$t('page.moralAgree.contentH')[1]}}</div>
          <div class="sign-content-text-partyname">{{$t('page.moralAgree.contentH')[2]}}</div>
          <div class="sign-content-text-info">{{$t('page.moralAgree.contentP')[0]}}</div>
          <div class="sign-content-text-title">{{$t('page.moralAgree.contentH')[3]}}</div>
          <p>{{$t('page.moralAgree.contentP')[1]}}</p>
          <p>{{$t('page.moralAgree.contentP')[2]}}</p>
          <p>{{$t('page.moralAgree.contentP')[3]}}</p>
          <p>{{$t('page.moralAgree.contentP')[4]}}</p>
          <div class="sign-content-text-title">{{$t('page.moralAgree.contentH')[4]}}</div>
          <p>{{$t('page.moralAgree.contentP')[5]}}</p>
          <p>{{$t('page.moralAgree.contentP')[6]}}</p>
          <p>{{$t('page.moralAgree.contentP')[7]}}</p>
          <p>{{$t('page.moralAgree.contentP')[8]}}</p>
          <p>{{$t('page.moralAgree.contentP')[9]}}</p>
          <p>{{$t('page.moralAgree.contentP')[10]}}</p>
          <p>{{$t('page.moralAgree.contentP')[11]}}</p>
          <P>{{$t('page.moralAgree.contentP')[12]}}</P>
          <p>{{$t('page.moralAgree.contentP')[13]}}</p>
          <div class="sign-content-text-title">{{$t('page.moralAgree.contentH')[5]}}</div>
          <p>{{$t('page.moralAgree.contentP')[14]}}</p>
          <p>{{$t('page.moralAgree.contentP')[15]}}</p>
          <p>{{$t('page.moralAgree.contentP')[16]}}</p>
          <p>{{$t('page.moralAgree.contentP')[17]}}</p>
          <p>{{$t('page.moralAgree.contentP')[18]}}</p>
          <p>{{$t('page.moralAgree.contentP')[19]}}</p>
          <P>{{$t('page.moralAgree.contentP')[20]}}</P>
          <p>{{$t('page.moralAgree.contentP')[21]}}</p>
          <P>{{$t('page.moralAgree.contentP')[22]}}</P>
          <P>{{$t('page.moralAgree.contentP')[23]}}</P>
          <P>{{$t('page.moralAgree.contentP')[24]}}</P>
          <P>{{$t('page.moralAgree.contentP')[25]}}</P>
          <P>{{$t('page.moralAgree.contentP')[26]}}</P>
          <P>{{$t('page.moralAgree.contentP')[27]}}</P>
          <P>{{$t('page.moralAgree.contentP')[28]}}</P>
          <P>{{$t('page.moralAgree.contentP')[29]}}</P>
          <div class="sign-content-text-title">{{$t('page.moralAgree.contentH')[6]}}</div>
          <P>{{$t('page.moralAgree.contentP')[30]}}</P>
          <P>{{$t('page.moralAgree.contentP')[31]}}</P>
          <div class="sign-content-text-title">{{$t('page.moralAgree.contentH')[7]}}</div>
          <P>{{$t('page.moralAgree.contentP')[32]}}</P>
          <div class="sign-content-text-title">{{$t('page.moralAgree.contentH')[8]}}</div>

        </div>
        <div v-else-if="isChinese === 'en-gb'" style="padding:0 10px 10px 10px">
          Dear Suppliers Associate(s):<br/>
          China Communications Construction Company Ltd. (CCCC) is an organization that has always been committed to the Code of Business Conduct and Ethics while edging its competitive advantage.<br/>
          All employees of CCCC should make a personal ethical commitment and at the same time, we also hope and request that all our supply associates should conform to a high standard of moral integrity. Your strong commitment in this area, aside from being mandatory for you to enter onto CCCC’S Suppliers Associates List,
          will also contribute to building up the basis of the mutually beneficial relationship between both our companies.<br/>
          Before advancing into the possibility of establishing a business relationship, we kindly ask you to confirm your company's commitment to comply with the Code of Business Conduct and Ethics of China Communications Construction Company Ltd. In particular,
          we need you to confirm that your company is:<br/>
          • Not employing staff members below the minimum legal age.<br/>
          • Not contracting any labours or staff through coercion or servitude.<br/>
          • Compliant with applicable laws and regulations on minimum wages, working hours and overtime hours.<br/>
          • Compliant with laws and regulations that protect the environment and local communities.<br/>
          • Providing workers for a safe and healthy work environment.<br/>
          • Maintaining and strengthening the company's policies in the area of business ethics, which includes the prohibition of official corruption.<br/>
          • Respecting the intellectual property rights of others.<br/>
          • Requesting a commitment to compliance with the similar ethical codes from your sub-contractors or business associates.<br/>
          It is crucial that your company comply and commit to these high ethical standards, as it is also an essential factor in establishing our business relationship.
        </div>
        <div v-else-if="isChinese === 'es-es'">
          Dear Suppliers Associate(s)：/Estimados Proveedores Asociados (s):<br/>
          China Communications Construction Company Ltd. (CCCC) is an organization that has always been committed to the Code of Business Conduct and Ethics while edging its competitive advantage./China Communications Construction Company Ltd.
          (CCCC) es una organización que siempre ha estado comprometida con el Código de Conducta y Ética Empresarial al tiempo que supera su ventaja competitiva.<br/>
          All employees of CCCC should make a personal ethical commitment and at the same time, we also hope and request that all our supply associates should conform to a high standard of moral integrity.
          Your strong commitment in this area, aside from being mandatory for you to enter onto CCCC’S Suppliers Associates List, will also contribute to building up the basis of the mutually beneficial relationship between both our companies.
          /Todos los empleados de CCCC deben hacer un compromiso ético personal y, al mismo tiempo, también esperamos y solicitamos que todos nuestros asociados de suministros se ajusten a un alto estándar de integridad moral.
          Su firme compromiso en esta área, además de ser obligatorio para que ingrese a la Lista de Asociados de Proveedores de CCCC, también contribuirá a construir la base de la relación mutuamente beneficiosa entre nuestras dos compañías.<br/>
          Before advancing into the possibility of establishing a business relationship, we kindly ask you to confirm your company's commitment to comply with the Code of Business Conduct and Ethics of China Communications Construction Company Ltd.
          In particular, we need you to confirm that your company is:/Antes de avanzar en la posibilidad de establecer una relación comercial, le pedimos que confirme el compromiso de su empresa de cumplir con el Código de conducta y ética empresarial de China Communications Construction Company Ltd.
          En particular, necesitamos que confirme que su empresa es:<br/>
          • Not employing staff members below the minimum legal age./No emplear a personal por debajo de la edad legal mínima.<br/>
          • Not contracting any labours or staff through coercion or servitude./No contratar ningún trabajo o personal por coerción o servidumbre.<br/>
          • Compliant with applicable laws and regulations on minimum wages, working hours and overtime hours./Cumple con las leyes y regulaciones aplicables sobre salarios mínimos, horas de trabajo y horas extras.<br/>
          • Compliant with laws and regulations that protect the environment and local communities./Cumple con las leyes y regulaciones que protegen el medio ambiente y las comunidades locales.<br/>
          • Providing workers for a safe and healthy work environment./Proporcionar trabajadores para un ambiente de trabajo seguro y saludable.<br/>
          • Maintaining and strengthening the company's policies in the area of business ethics, which includes the prohibition of official corruption./Mantener y fortalecer las políticas de la compañía en el área de ética empresarial, que incluye la prohibición de la corrupción oficial.<br/>
          • Respecting the intellectual property rights of others./Respetando los derechos de propiedad intelectual de los demás.<br/>
          • Requesting a commitment to compliance with the similar ethical codes from your sub-contractors or business associates./Solicitar un compromiso de cumplimiento con los códigos de ética similares de sus subcontratistas o socios comerciales.<br/>
          It is crucial that your company comply and commit to these high ethical standards, as it is also an essential factor in establishing our business relationship./Es crucial que su empresa cumpla y se comprometa con estos altos estándares éticos,
          ya que también es un factor esencial para establecer nuestra relación comercial.
        </div>
        <div v-else-if="isChinese === 'fr-fr'">
          Cher(s) Fournisseur(s) associé(s),<br/>
          China Communications Construction Company Ltd. (CCCC) est une société qui a toujours été attaché au Code de conduite et à l'éthique des affaires tout en renforçant son avantage concurrentiel.Tous les employés de CCCC doivent prendre un engagement éthique personnel et en même temps,
          nous espérons et demandons également que tous nos associés d'approvisionnement se conforment à un niveau élevé d'intégrité morale.
          Votre engagement ferme dans ce domaine, en plus de vous obliger à entrer sur la liste des fournisseurs associés de CCCC, contribuera également à jeter les bases de la relation mutuellement avantageuse entre nos deux sociétés.<br/>
          Avant d'avancer dans la possibilité d'établir une relation commerciale, nous vous demandons de bien vouloir confirmer l'engagement de votre entreprise à se conformer au Code de conduite et d'éthique professionnelle de China Communications Construction Company Ltd. En particulier,
          nous avons besoin que vous confirmiez que votre entreprise est:<br/>
          • Ne pas employer de personnel en dessous de l’âge légal minimum<br/>
          • Ne pas contracter de travail ou de personnel par la coercition ou la servitude<br/>
          • Conforme aux lois et réglementations qui protègent l'environnement et les communautés locales<br/>
          • Offrir aux travailleurs un environnement de travail sûr et sain.<br/>
          • Maintenir et renforcer les politiques de l'entreprise dans le domaine de l'éthique des affaires, qui comprend l'interdiction de la corruption officielle<br/>
          • Respecter les droits de propriété intellectuelle d'autrui<br/>
          • Demander un engagement à respecter les codes d'éthique similaires de la part de vos sous-traitants ou associés.<br/>
          Il est essentiel que votre entreprise se conforme et s'engage à respecter ces normes éthiques élevées, car c'est également un facteur essentiel dans l'établissement de notre relation commerciale.
        </div>
      </div>
      <el-checkbox v-model="checked">{{$t('page.moralAgree.contentCheckbox')[0]}}</el-checkbox>
    </div>
    <div class="btnBox">
      <el-button
        class="left-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="pre()"
      >
        <span>{{ $t('basicLayout.btn')[0] }}</span>
      </el-button>
      <el-button
        class="right-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="next()"
      >
        <span>{{ $t('basicLayout.btn')[1] }}</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import Setting from "@/config/index";
import Cookies from "js-cookie";
const savedLocaleKey = Setting.i18n.cookieLable;

export default {
  name: "moralAgreement",
  data() {
    return {
      checked: false,
      isChinese: Cookies.get(savedLocaleKey),
    }
  },
  methods: {
    ...mapActions(["changeCheckPage"]),
    pre() {
      this.changeCheckPage(1)
      this.$router.push({
        path:'/maReady02',
        query: {
          tempSupinfoId: this.$route.query.tempSupinfoId?this.$route.query.tempSupinfoId:this.tempSupinfoId,
          tempOrFormalFlag:this.$route.query.tempOrFormalFlag
        }
      })
    },
    next() {
      if(this.checked) {
        this.changeCheckPage(3)
        this.$router.push({
          path: '/maPerfectInfo/applyUsername',
          query: {
            tempSupinfoId:this.$route.query.tempSupinfoId,
            tempOrFormalFlag:this.$route.query.tempOrFormalFlag,
            v:Math.random()
          }
        })
      } else {
        this.$message.error(window.$t('page.moralAgree.errMsg')[0])
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .sign-content {
    width: 1180px;
    height: 520px;
    background: #FFFFFF;
    margin: 20px auto;
    overflow: hidden;
    .sign-content-h2 {
      font-size: 16px;
      line-height: 22px;
      color: #4A4A4A;
      font-weight: 600;
      margin-left: 70px;
      margin-top: 20px;
      }
    .sign-content-text {
      width: 1000px;
      height: 400px;
      border: 1px solid #D8D8D8;
      border-radius: 4px;
      overflow-y: scroll;
      margin: 20px auto;
      .sign-content-text-h2 {
        margin: 20px auto;
        font-size: 20px;
        text-align: center;
        font-weight: 600;
      }
      .sign-content-text-main{
        width: 960px;
        margin: 20px auto;
        .sign-content-text-partyname{
          font-size: 13px;
          font-weight: 600;
          line-height: 20px;
        }
        .sign-content-text-info{
          margin-top: 20px;
          font-size: 13px;
          line-height: 20px;
          color: #999999;
        }
        .sign-content-text-title{
          margin-top: 20px;
          font-size: 13px;
          font-weight: 600;
          line-height: 20px;
        }
        p {
          font-size: 13px;
          line-height: 22px;
          color: #999999;
        }
      }




      h5 {
        margin-top: 20px;
        margin-left: 20px;
      }
      h5:nth-child(3) {
        margin-top: 0px;
        margin-bottom: 20px;
      }
    }
    .el-checkbox {
      margin-left: 90px;
      margin-right: 10px;
      vertical-align: middle;
    }
    span {
      font-family: PingFangSC-Regular;
      font-size: 13px;
      color: #4A4A4A;
      font-weight: 400;
    }
  }
  .btn {
    width: 240px;
    height: 40px;
    background: #FF142F;
    margin-bottom: 20px;
    span {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFangSC;
      font-weight: 600;
    }
  }
  .btnBox {
    margin: 0px auto;
    width: 500px;
  }
</style>
